<template>
  <div id="app">
    <!-- <h1 style="font-family: 'PringleandTweed'">Our Time</h1> -->
    <!-- <img src="./assets/logo.png">
    <h1>{{ msg }}</h1>
    <h2>Essential Links</h2>
    <ul>
      <li><a href="https://vuejs.org" target="_blank">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank">Forum</a></li>
      <li><a href="https://chat.vuejs.org" target="_blank">Community Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank">Twitter</a></li>
    </ul>
    <h2>Ecosystem</h2>
    <ul>
      <li><a href="http://router.vuejs.org/" target="_blank">vue-router</a></li>
      <li><a href="http://vuex.vuejs.org/" target="_blank">vuex</a></li>
      <li><a href="http://vue-loader.vuejs.org/" target="_blank">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank">awesome-vue</a></li>
    </ul> -->

    <!-- <main-header></main-header>
    <timeline class="mb-5"></timeline> -->

    <nav
      class="navbar web-only"
      style="position: absolute; width: 100%"

    >
      <!-- <nav class="navbar fixed-top web-only" style="width: 100%; background-color: #fcbf67;"> -->
      <router-link
        to="/"
        class="navbar-brand"
      >
        <!-- <img src="./assets/logo.png" width="30" height="30" alt=""> -->

        <!-- <img v-if="$router.history.current.path == '/2'" src="./assets/img/logo/enginehire logo thin dark blue 1.1 letterpaths.svg" width="" height="55" alt="Enginehire" style="" class="my-1" id='nav-logo'>
          <img v-else src="./assets/img/logo/enginehire logo thin light 1.0 letterpaths.svg" width="" height="55" alt="Enginehire" style="" class="my-1" id='nav-logo'> -->

        <!-- <img
          src="./assets/img/logo/momtalkingtomoms_logo1.0_white.svg"
          width=""
          height="85"
          alt="needumom"
          style=""
          class="my-1 px-3"
          id="nav-logo"
        /> -->
        <h1 class="mt-3 pl-2" style="font-family: 'PringleandTweed'; color: white;" id="nav-logo">Daily Timeline</h1>
      </router-link>
      <!-- <button style="margin-top: 0px; margin-right: 10px; float: right;" class="mylisting-button light-button">Book a Demo</button> -->
      <!-- <div
        v-if="$router.history.current.path !='/contact'"
        class=""
        style="margin-top: -10px; margin-right: 10px;"
      >
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button light-button shadow"
        >Book a Demo</router-link>
      </div> -->
      <!-- <a
        href=""
        class="mylisting-button light-button"
        onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
        >Book a Demo</a
      > -->

      <div
        class="collapse navbar-collapse"
        id="navbarNavAltMarkup"
      >
        <div class="navbar-nav">
          <!-- <router-link
            :to="{ name: 'Book Demo' }"
            class="nav-item nav-link"
          >Learn More</router-link> -->
          <!-- <a
            class="nav-item nav-link"
            href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
          >Google Reviews</a> -->
          <!-- <a
            class="nav-item nav-link"
            href="#"
          >Get Started</a> -->
          <!-- <router-link
            :to="{ name: 'Get Started' }"
            class="nav-item nav-link"
          >Get Started</router-link> -->
          <!-- <a
            class="nav-item nav-link"
            href="https://www.g2.com/products/enginehire/reviews"
            target="_blank"
          >Reviews</a> -->

          <!-- <router-link
            :to="{ name: 'Backup Care Assistant' }"
            class="nav-item nav-link"
          >Backup Care Assistant</router-link> -->
          <a
            class="nav-item nav-link"
            href="https://learn.enginehire.io/en/knowledge/kb-tickets/new"
            target="_blank"
          >Customer Support</a>
        </div>
      </div>

      <div
        v-if="$router.history.current.path =='/'"
        class=""
        style="margin-top: -55px; margin-right: 10px;"
      >
        <!-- <router-link
          :to="{ name: 'Login' }"
          class="mylisting-button dark-button"
        >Login</router-link> -->
        <!-- <button class="mylisting-button dark-button">
          <a
            href="https://app.momstalkingtomoms.com/login/409"
          >Log In</a>
        </button> -->
      </div>
      <!-- <div
        v-else
        class=""
        style="margin-top: -10px; margin-right: 10px;"
      >
        <router-link
          :to="{ name: 'Login' }"
          class="mylisting-button dark-button"
        >Login</router-link>
      </div> -->
    </nav>
    <!-- </div> -->

    <nav
      class="navbar mobile-only"
      style="position: absolute; width: 100%"
      v-if="$router.history.current.path != '/book-demo'"
    >
      <router-link
        to="/"
        class="navbar-brand"
        style="margin-right: 0;"
      >
        <!-- <img src="./assets/logo.png" width="30" height="30" alt=""> -->
        <!-- <img src="./assets/img/logo/enginehire logo thin dark blue 1.1 letterpaths.svg" width="" height="50" alt="Enginehire" style="" id='nav-logo'> -->
        <!-- <img src="./assets/img/logo/enginehire logo thin light 1.0 letterpaths.svg" width="" height="50" alt="Enginehire" style="" id='nav-logo'> -->
        <!-- <img
          src="./assets/img/logo/momtalkingtomoms_logo1.0_white.svg"
          width=""
          height="65"
          alt="Moms Talking to Moms"
          style=""
          class="my-1 px-2"
          id="nav-logo"
        /> -->
        <h3 class="mt-1" style="font-family: 'PringleandTweed'; color: white; float: left; margin-right: 0;" id="nav-logo">Daily Timeline</h3>
      </router-link>
      <!-- <button style="margin-top: 5px; margin-right: -5px; float: right;" class="mylisting-button-small light-button">Book a Demo</button> -->
      <!-- <a class="mylisting-button-small light-button shadow" href="https://www.enginehire.io/contact/">Book a Demo</a> -->
      <div
        v-if="$router.history.current.path != '/book-demo'"
        class=""
        style="float: right; margin-top: 14px; margin-right: 14px"
      >
        <!-- <router-link
          :to="{ name: 'Login' }"
          class="mylisting-button-small light-button shadow"
        >Log In</router-link> -->
      </div>
      <!-- <div
        v-if="$router.history.current.path =='/'"
        class=""
        style="margin-top: -10px; margin-right: 10px;"
      >
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button dark-button"
        >Login</router-link>
      </div> -->
    </nav>

    <router-view></router-view>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Timeline from './components/Timeline.vue'

export default {
  name: 'app',
  components: {
    MainHeader: Header,
    Timeline,
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  created() {
    // this.$store.dispatch('initStocks');
    this.$store.dispatch('tryAutoLogin')
    // this.getUser()
  },
}
</script>

<style>
:root {
  --coredarkcolor: #212944;
  --caredarkercolor: #56a;
  --corelightcolor: #fff;
  --bootstrapgrey: #e9ecef;
  --skyblue: #bfe7ff;
  --thrivehiregrey: #d9d9da;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

pre {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 100%;
  /* overflow-x: hidden; */
  /* overflow-wrap: break-word; */
  /* Prevent side scrolling of long lines */
  white-space: pre-wrap; /* https://mediatemple.net/blog/tips/considerations-for-styling-the-pre-tag/ */
  margin-bottom: 0;
}

/* ------- BUTTONS -------- */
.mylisting-button {
  min-width: 135px;
  text-align: center;
  font-family: "Open Sans";
  font-weight: 600;
  /* margin-top: 20px; */
  padding: 11px 22px;
  border-radius: 0px;
  font-size: 14px;
  /* height: 48px; */
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  z-index: 0;
  -webkit-box-pack: center;
  justify-content: center;
  white-space: nowrap;
  /* border: 2px solid #0c4524; */
  border: 2px solid var(--coredarkcolor);
  /* margin-top: 10px; */
  /* background-size: 200% 100%;
    background-position: right bottom;
    transition: all .25s ease-out; */
}

/* This is to get rid of underlining for router links used as buttons */
a.mylisting-button:hover {
  text-decoration: none;
}

.dark-button {
  /* color: #0c4524; */
  color: var(--coredarkcolor);
  background-color: white;
  /* Add a shadow over the search button left to right when you hover over it */
  /* https://codepen.io/kay8/pen/azKbjN */
  /* https://stackoverflow.com/questions/17212094/fill-background-color-left-to-right-css */
  /* background: linear-gradient(to right, var(--coredarkercolor) 50%, var(--coredarkcolor) 50%); */
  /* background-size: 200% 100%; */
  /* background-position: right bottom; */
  /* transition: all .25s ease-out; */
}
.dark-button:hover {
  color: #fff;
  /* background-position: left bottom; */
  /* background-color: #0c4524; */
  background-color: var(--coredarkcolor);
}

.secondary-button {
  /* color: #fff; */
  color: var(--coredarkcolor);
  background: linear-gradient(to right, #4d4d4d 50%, var(--thrivehiregrey) 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.secondary-button:hover {
  color: #fff;
  background-position: left bottom;
}

.danger-button {
  color: #fff;
  background: linear-gradient(to right, #cc0000 50%, red 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.danger-button:hover {
  color: #fff;
  background-position: left bottom;
}
/* --------------------- */

.field-of-fields label {
  /* font-family: 'articulatcf-demibold', 'Lato'; */
  color: var(--coredarkcolor);
  /* color: black; */
  /* color: grey; */
  /* font-size: 0.8rem; */
  font-weight: 600;
  margin-top: 25px;
  margin-bottom: 2px;
}
.field-of-fields .top-label {
  margin-top: 0;
}

.card-img-top {
  width: 100%;
  border-bottom-left-radius: calc(.25rem - 1px);
  border-bottom-right-radius: calc(.25rem - 1px);
}

/* --------------------------------------------------------- */

  @media (max-width: 1370px) {
    .dashboard-header.medium-shrink {
      font-size: 19px;
    }
  }

  @media (max-width: 1235px) {
    .medium-shrink h1 {
      font-size: 3px;
    }
    h1 {
      font-size: 2rem;
    }

    .dashboard-header.medium-shrink {
      font-size: 16px;
    }
  }

  .mobile-only {
    display: none;
  }

  @media (max-width: 768px) {
    .web-only {
      display: none;
    }
    .mobile-only {
      display: inherit;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue